import { render, staticRenderFns } from "./AddPrivilegeInventoryModal.vue?vue&type=template&id=631576ad&scoped=true&"
import script from "./AddPrivilegeInventoryModal.vue?vue&type=script&lang=js&"
export * from "./AddPrivilegeInventoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPrivilegeInventoryModal.vue?vue&type=style&index=0&id=631576ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631576ad",
  null
  
)

export default component.exports